import { useState } from "react";
import { useContent } from "@/contexts/ContentContext";
import { ColorPanel } from "@/components/ColorPanel";
import { CMS } from "@/constants/testIds/cms";

export function AdminBar({ onManageAdmins, onEditResources }) {
  const { editMode, setEditMode, save, saving } = useContent();
  const [showColors, setShowColors] = useState(false);

  if (!editMode) return null;

  return (
    <>
      <div className="admin-bar">
        <div className="left">
          <span className="dot" /> Edit mode is on. Click any text to change it. Changes are visible to every visitor once saved.
        </div>
        <div className="actions">
          <button onClick={() => setShowColors((s) => !s)} data-testid={CMS.colorToggleButton}>
            Colors
          </button>
          <button onClick={onEditResources} data-testid={CMS.editResourcesButton}>
            Resources
          </button>
          <button onClick={onManageAdmins} data-testid={CMS.manageAdminsButton}>
            Manage admins
          </button>
          <button className="primary" onClick={save} disabled={saving} data-testid={CMS.saveButton}>
            {saving ? "Saving…" : "Save changes"}
          </button>
          <button onClick={() => setEditMode(false)} data-testid={CMS.exitEditButton}>
            Exit edit mode
          </button>
        </div>
      </div>
      {showColors && <ColorPanel />}
    </>
  );
}
